





import HappyHoursSettings from '@/views/HappyHours/HappyHoursSettings.vue';

export default {
  name: 'StakingViewProgramsHappyHours',
  components: {
    HappyHoursSettings
  }
};
